import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { DSCard } from './Card';
import { GenericWCWrapper, Slots } from '../utils';
export var DSCardContent = /*#__PURE__*/function (_GenericWCWrapper) {
  _inherits(DSCardContent, _GenericWCWrapper);

  var _super = _createSuper(DSCardContent);

  function DSCardContent() {
    var _this;

    _classCallCheck(this, DSCardContent);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "slotName", Slots.body);

    _defineProperty(_assertThisInitialized(_this), "parentName", DSCard.name);

    return _this;
  }

  return DSCardContent;
}(GenericWCWrapper);
//# sourceMappingURL=CardContent.js.map